<div class="box bg-gradient">
  <div nz-row class="box card-login-wrapper">
    <app-card-standalone [title]="'PAGE.AUTH.LOGIN.TITLE' | translate">
      <div>
        <app-auth-form></app-auth-form>

        <a routerLink="/forgot-password">
          {{ "PAGE.AUTH.LOGIN.FORGOT_PASSWORD" | translate }}
        </a>
      </div>
    </app-card-standalone>

    <div class="select-lang-wrapper">
      <app-select-language></app-select-language>
    </div>
  </div>
</div>
